<template>
    <div class="music" :class="[!isPlaying && 'paused']" v-if="activityData && activityData.music && activityData.music.isShow && activityData.music.musicUrl" @touchstart.stop="switchMusic">
        <audio ref="audio" @play="play" @pause="pause" :src="activityData.music.musicUrl" loop autoplay></audio>
        <img src="../assets/img/music_btn.png" alt="">
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState, mapMutations } from 'vuex'

export default defineComponent({
    name: 'BaseComponent',
    data () {
        return {
            isPlaying: false
        }
    },
    computed: {
        ...mapState(['musicPaused', 'activityData'])
    },
    watch: {
        musicPaused (val) {
            const audioDom = this.$refs.audio as HTMLAudioElement
            if (!audioDom) {
                return
            }
            if (val) {
                audioDom.pause()     
            } else {
                audioDom.play()
            }
        },
        activityData(val){
            this.$nextTick(() => {
                this.firstPaly()
            })
        }
    },
    mounted () {
        // this.$nextTick(() => {
        //     this.firstPaly()
        // })
    },
    methods: {
        ...mapMutations(['SET_MUSICPAUSED']),
        firstPaly (): void {
            const audioDom = this.$refs.audio as HTMLAudioElement
            if (!audioDom) {
                console.log('没有dom')
                return
            }
            if (!this.musicPaused) {
                console.log('没有播放')
                audioDom.play()
            }
            // 微信自动播放
            document.addEventListener("WeixinJSBridgeReady", () => {
                console.log('微信播放')
                if (!this.musicPaused) {
                    audioDom.play()
                }
            }, false)
            // 兼容其他不自动播放的情况
            document.addEventListener("touchstart", () => {
                console.log('点击')
                if (!this.musicPaused) {
                    audioDom.play()
                }
            }, false)
            audioDom.addEventListener("ended", () => {
                console.log('播放结束')
                if (!this.musicPaused) {
                    audioDom.play()
                }
            }, false)
        },
        switchMusic (): void {
            this.SET_MUSICPAUSED(!this.musicPaused)
        },
        play (): void {
            this.isPlaying = true
        },
        pause (): void {
            this.isPlaying = false
        }
    }
})
</script>

<style lang="scss">
.music {
    position: fixed;
    right: 15vw;
    top: 3.6vw;
    width: 5.37037vw;
    height: 5.37037vw;
    overflow: hidden;
    z-index: 10;
    cursor: pointer;
    audio {
        display: none;
    }
    animation: rotate 3s infinite linear;
    &.paused {
        animation-name: none;
        img {
            position: absolute;
            left: 0;
            bottom: 0;
        }
    }
}

@keyframes rotate {
    100% {
        transform: rotate(360deg);
    }
}
</style>